import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 添加编辑租赁
 */
export const fetchAddEditLease = async (data) => {
    const res = await POST(APIs.API_SERVICE_ADDEDITLEASE, { data });

    return res.data.data ?? {};
};

/**
 * 租赁详情
 */
export const fetchLeaseInfo = async (service_id) => {
    const res = await GET(APIs.API_SERVICE_LEASEINFO, { params: { service_id } });

    return res.data.data ?? {};
};

/**
 * 取消服务
 */
export const fetchCancelService = async (id) => {
    const res = await POST(APIs.API_SERVICE_CANCELSERVICE, { data: { id } });

    return res.data ?? {};
};

/**
 * 删除租赁物品
 */
export const fetchDeleteLeaseItem = async (id) => {
    const res = await POST(APIs.API_SERVICE_DELETELEASEITEM, { data: { id } });

    return res.data.data ?? {};
};

/**
 * 一键归还
 */
export const fetchGiveBack = async (id) => {
    const res = await POST(APIs.API_SERVICE_GIVEBACK, { data: { id } });

    return res.data ?? {};
};